/** searches through an array for unique values */
export function findUniqueVals( data: any[], getValueFunc: Function ) {
    // search through the data and find which values are present
    // this function would technically work fine on analog data but there is currently no use case for that
    const valKeys = {};
    data.forEach( point => {
        valKeys[ getValueFunc( point ) ] = true;
    });
    // the values of the keys in valKeys now are associated with the unique y-values found in the data.
    return Object.keys( valKeys ).map( val => {
        return parseInt( val, 10 );
    }).sort( ( a, b ) => {
        return a - b;
    });
}

/**
 * find the min and max values in an entire array
 * getValFunc returns the value to compare, so that if it's an array of objects,
 * we can compare the value of a property of each object in the array
 */
export function arrayMinMax( array: number[], getValFunc?: Function ) {
    if ( typeof getValFunc === 'undefined' ) {
        getValFunc = function( arrayElement ) {
            return arrayElement;
        };
    }
    let min = Number.MAX_VALUE;
    let max = -Number.MAX_VALUE;
    // find min and max values of used values
    array.forEach( function(val) {
        min = Math.min( min, getValFunc(val) );
        max = Math.max( max, getValFunc(val) );
    });
    return {
        min: min !== Number.MAX_VALUE ? min : null, // return null if we were unable to calculate min/max numbers
        max: max !== -Number.MAX_VALUE ? max : null
    };
}

/**
 * create a random ID. We can use this to identify objects between plots
 */
export function createUID() {
    // Math.random should be unique because of its seeding algorithm.
    // Convert it to base 36 (numbers + letters), and grab the first 9 characters
    // after the decimal.
    return '_' + Math.random().toString(36).substr(2, 9);
}
